import { axios } from '@/services/axios';

export const updateRegistrar = (registrarData, currentScope) => {
    const res = axios.put('/TRSRegistrar', registrarData, {
        'X-RequestScope': currentScope,
    });
    return res;
};
